import {Component, Input, OnInit} from '@angular/core';
import {SummaryCardTemplateComponent} from '../common/summary-card-template/summary-card-template.component';
import {LogBook} from '../../models/error/LogBook';

@Component({
    selector: 'app-log-book-summary-card',
    templateUrl: './log-book-summary-card.component.html',
    styleUrls: ['./log-book-summary-card.component.css'],
    standalone: true,
    imports: [SummaryCardTemplateComponent]
})
export class LogBookSummaryCardComponent implements OnInit {
    @Input({required: true, alias: "loggableEntity"}) logBook!: LogBook;

    constructor() {
    }

    ngOnInit() {
    }

}
